// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import AddForm from "./addForm";
import Details from "./details";
import Table from "./table";
import UpdateForm from "./updateForm";

import { IUserProps } from "./common";
import { useAuth } from "./hooks";
import PermissionHelper, {
  MenuIndex
} from "../../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const User: FunctionComponent<IUserProps> = ({ menuIndex }) => {
  // ---------------------------------------------- router state
  let match = useRouteMatch();

  // ---------------------------------------------- local state
  const { profile, areLoaded, isEmptied } = useAuth();

  // ---------------------------------------------- content
  return !areLoaded ? null : isEmptied ||
    !match ||
    !PermissionHelper.getView(profile.permissions, MenuIndex.User) ? (
    <Redirect to="/login" />
  ) : (
    <>
      <Route
        exact
        path={match.path}
        render={props => <Table {...props} menuIndex={menuIndex}></Table>}
      />

      <Switch>
        <Route
          exact
          path={`${match.path}/add`}
          render={props => <AddForm {...props} menuIndex={menuIndex}></AddForm>}
        />

        <Route
          exact
          path={`${match.path}/update/:user_id`}
          render={props => (
            <UpdateForm {...props} menuIndex={menuIndex}></UpdateForm>
          )}
        />

        <Route
          exact
          path={`${match.path}/:user_id`}
          render={props => <Details {...props} menuIndex={menuIndex}></Details>}
        />
      </Switch>
    </>
  );
};

export default User;
